var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"ma-0":"","pa-0":""}},[_c('div',{staticClass:" accent achtergrond"},[_c('v-main',[_c('transition',{attrs:{"enter-active-class":"animate__animated animate__slideInDown","appear":""}},[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }